import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";

export default function ScrollToTopButton() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 300);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    if (!visible) return null;

    return (
        <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            style={{
                position: "fixed",
                right: 16,
                bottom: 16,
                zIndex: 9999,
                width: 52,
                height: 52,
                borderRadius: "50%",
                border: "none",
                background: "#3b73ff",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 24px rgba(0,0,0,.18)",
                cursor: "pointer"
            }}
            aria-label="Voltar ao topo"
            title="Voltar ao topo"
        >
            <FontAwesomeIcon icon={faArrowUp} style={{ fontSize: 22 }} />
        </button>
    );
}